import React, { Fragment, useEffect, useState } from "react";
import "./dashboard.scss";
import { useNavigate } from "react-router-dom";
import { Card } from "react-bootstrap";
import moment from "moment";
import { academyusergetdetail } from "../../services/admin";

function Dashboard() {
  const navigate = useNavigate();
  const [role, setRole] = useState("");
  const [academy, setAcademy] = useState("");
  useEffect(() => {
    academyusergetdetail(localStorage.getItem("UID")).then((res) => {
      if (res.status === true) {
        setAcademy(res.data.details.academy_name);
        setRole(res.data.details.role_name);
      }
    });

  }, []);
  const startAutoScroll = () => {
    const scrollContainer = document.getElementById('auto-scroll');
    const announcementList = document.getElementById('announcement-list');

    // Duplicate the list for seamless scrolling
    if (!announcementList.classList.contains('duplicated')) {
      const clone = announcementList.cloneNode(true);
      clone.id = '';
      clone.classList.add('duplicate');
      scrollContainer.appendChild(clone);
      announcementList.classList.add('duplicated');
    }

    const scrollSpeed = 1; // Pixels per step

    if (scrollContainer) {
      window.scrollInterval = setInterval(() => {
        scrollContainer.scrollTop += scrollSpeed;

        // Reset scroll position when reaching the end of the first list
        if (scrollContainer.scrollTop >= announcementList.scrollHeight) {
          scrollContainer.scrollTop = 0;
        }
      }, 30); // Interval in milliseconds
    }
  };


  // Start auto-scrolling on page load
  document.addEventListener('DOMContentLoaded', startAutoScroll);
  const startBirthdayScroll = () => {
    const scrollContainer = document.getElementById('birthday-scroll');
    const birthdayList = document.getElementById('birthday-list');

    // Duplicate the list for seamless scrolling
    if (!birthdayList.classList.contains('duplicated')) {
      const clone = birthdayList.cloneNode(true);
      clone.id = '';
      clone.classList.add('duplicate');
      scrollContainer.appendChild(clone);
      birthdayList.classList.add('duplicated');
    }

    const scrollSpeed = 1; // Pixels per step

    if (scrollContainer) {
      window.scrollInterval = setInterval(() => {
        scrollContainer.scrollTop += scrollSpeed;

        // Reset scroll position when reaching the end of the first list
        if (scrollContainer.scrollTop >= birthdayList.scrollHeight) {
          scrollContainer.scrollTop = 0;
        }
      }, 30); // Interval in milliseconds
    }
  };

  // Start auto-scrolling on page load
  document.addEventListener('DOMContentLoaded', startBirthdayScroll);


  return (
    <Fragment>
      <div className="main-container container-fluid">
        <div className="inner-body">
          {/* Page Header */}
          <div className="page-header">
            <h2 className="main-content-title tx-24 mg-b-5">
              Welcome To Dashboard
            </h2>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a>Home</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Dashboard
              </li>
            </ol>
          </div>
          {/* End Page Header */}
          {/*Row*/}
          <div className="row row-sm">
            <div className="col-sm-12 col-lg-12 col-xl-8">
              {/*Row*/}
              <div className="row row-sm  mt-lg-4">
                <div className="col-sm-12 col-lg-12 col-xl-12">
                  <div className="bg-black-2 custom-card card-box card">
                    <div className="card-body p-4">
                      <div className="row align-items-center">
                        <div className="offset-xl-3 offset-sm-6 col-xl-8 col-sm-6 col-12 img-bg ">
                          <h4 className="d-flex  mb-3">
                            <span className="font-weight-bold text-white ">
                              {localStorage.getItem("Role") == 1
                                ? "Super Admin"
                                : `${academy}`}
                            </span>
                          </h4>
                          <p className="tx-white-7 mb-1">
                            Welcome Back{" "}
                            <b className="text-warning">
                              {localStorage.getItem("Role") == 1
                                ? "Super Admin"
                                : `${role}`}
                            </b>{" "}
                            See our Todays Dashboard{" "}
                            <b className="text-warning">
                              {moment(new Date()).format("DD-MM-YYYY")}
                            </b>
                            <br></br>
                            Have a Nice Day
                          </p>
                        </div>
                        <img
                          src={require("../../assets/images/dashboard/admin.png")}
                          alt="Student"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/*Row */}
              {/*Row*/}
              <div className="col-sm-12 col-lg-12 col-xl-12">
                <div className="row row-sm">
                  <div class="col-md-6 col-xl-4">
                    <div class="card custom-card">
                      <div class="card-bodyy">
                        <div class="row">
                          <div class="col-lg-12">
                            <div className="product-content">
                              <h3 className="title">
                                <a href="#">STUDENTS</a>
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                        <div className="col-md-4 col justify-content-center text-center">
                          <h3 className="mb-1 font-weight-bold">
                            {" "}
                            <a href="#">10</a>{" "}
                            <p className="text-muted ">Present </p>
                          </h3>

                        </div>
                        <div className="col-md-4 col text-center">
                          <h3 className="mb-1 font-weight-bold">
                            {" "}
                            <a href="#">7</a>{" "}
                            <p className="text-muted ">Absent</p>
                          </h3>

                        </div>
                        <div className="col-md-4 col text-center">
                          <h3 className="mb-1 font-weight-bold">
                            {" "}
                            <a href="#">3</a>{" "}
                            <p className="text-muted ">Total</p>
                          </h3>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-xl-4">
                    <div class="card custom-card">
                      <div class="card-bodyy">
                        <div class="row">
                          <div class="col-lg-12">
                            <div className="product-content">
                              <h3 className="title">
                                <a href="#">TEACHERS</a>
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                        <div className="col-md-4 col justify-content-center text-center">
                          <h3 className="mb-1 font-weight-bold">
                            {" "}
                            <a href="#">10</a>{" "}
                            <p className="text-muted ">Present</p>
                          </h3>

                        </div>
                        <div className="col-md-4 col text-center">
                          <h3 className="mb-1 font-weight-bold">
                            {" "}
                            <a href="#">7</a>{" "}
                            <p className="text-muted ">Absent </p>
                          </h3>

                        </div>
                        <div className="col-md-4 col text-center">
                          <h3 className="mb-1 font-weight-bold">
                            {" "}
                            <a href="#">3</a>{" "}
                            <p className="text-muted ">Total</p>
                          </h3>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-xl-4">
                    <div class="card custom-card">
                      <div class="card-bodyy">
                        <div class="row">
                          <div class="col-lg-12">
                            <div className="product-content">
                              <h3 className="title">
                                <a href="#">WORKERS</a>
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                        <div className="col-md-4 col justify-content-center text-center">
                          <h3 className="mb-1 font-weight-bold">
                            {" "}
                            <a href="#">10</a>{" "}
                            <p className="text-muted ">Present</p>
                          </h3>

                        </div>
                        <div className="col-md-4 col text-center">
                          <h3 className="mb-1 font-weight-bold">
                            {" "}
                            <a href="#">7</a>{" "}
                            <p className="text-muted ">Absent</p>
                          </h3>

                        </div>
                        <div className="col-md-4 col text-center">
                          <h3 className="mb-1 font-weight-bold">
                            {" "}
                            <a href="#">3</a>{" "}
                            <p className="text-muted ">Total</p>
                          </h3>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-xl-4">
                    <div className="card custom-card">
                      <div className="card-bodyy">
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="product-content">
                              <h3 className="title">
                                <a href="#" >FEE COLLECTION</a>
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                        <div className="col-md-6 col justify-content-center text-center">
                          <h3 className="mb-1 font-weight-bold">
                            {" "}
                            <a >₹ 456</a>{" "}
                            <p className="text-muted ">Today</p>
                          </h3>
                        </div>
                        <div className="col-md-6 col text-center float-end">
                          <h3 className="mb-1 font-weight-bold">
                            {" "}
                            <a >₹ 556</a>{" "}
                            <p className="text-muted">Total</p>
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-xl-4">
                    <div className="card custom-card">
                      <div className="card-bodyy">
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="product-content">
                              <h3 className="title">
                                <a href="#" >GENERAL ACCOUNTS</a>
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                        <div className="col-md-6 col justify-content-center text-center">
                          <h3 className="mb-1 font-weight-bold">
                            {" "}
                            <a >₹ 456</a>{" "}
                            <p className="text-muted ">Income</p>
                          </h3>
                        </div>
                        <div className="col-md-6 col text-center float-end">
                          <h3 className="mb-1 font-weight-bold">
                            {" "}
                            <a >₹ 556</a>{" "}
                            <p className="text-muted">Expenses</p>
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-xl-4">
                    <div className="card custom-card">
                      <div className="card-bodyy">
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="product-content">
                              <h3 className="title">
                                <a href="#">ADMISSION</a>
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                        <div className="col-md-6 col justify-content-center text-center">
                          <h3 className="mb-1 font-weight-bold">
                            {" "}
                            <a >456</a>{" "}
                            <p className="text-muted ">Today</p>
                          </h3>
                        </div>
                        <div className="col-md-6 col text-center float-end">
                          <h3 className="mb-1 font-weight-bold">
                            {" "}
                            <a >556</a>{" "}
                            <p className="text-muted">Total</p>
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-xl-4">
                    <div className="card custom-card">
                      <div className="card-bodyy">
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="product-content">
                              <h3 className="title">
                                <a href="#">ENQUIRY</a>
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                        <div className="col-md-6 col justify-content-center text-center">
                          <h3 className="mb-1 font-weight-bold">
                            {" "}
                            <a >456</a>{" "}
                            <p className="text-muted ">Today</p>
                          </h3>
                        </div>
                        <div className="col-md-6 col text-center float-end">
                          <h3 className="mb-1 font-weight-bold">
                            {" "}
                            <a >556</a>{" "}
                            <p className="text-muted">Total</p>
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-xl-4">
                    <div className="card custom-card">
                      <div className="card-bodyy">
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="product-content">
                              <h3 className="title">
                                <a href="#">COMPLAINTS</a>
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                        <div className="col-md-6 col justify-content-center text-center">
                          <h3 className="mb-1 font-weight-bold">
                            {" "}
                            <a>0</a>{" "}
                            <p className="text-muted ">Today</p>
                          </h3>
                        </div>
                        <div className="col-md-6 col text-center float-end">
                          <h3 className="mb-1 font-weight-bold">
                            {" "}
                            <a>0</a>{" "}
                            <p className="text-muted">Total</p>
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 col-xl-4">
                    <div className="card custom-card">
                      <div className="card-bodyy">
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="product-content">
                              <h3 className="title">
                                <a href="#">HOSTEL STUDENTS</a>
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                        <div className="col-md-6 col justify-content-center text-center">
                          <h3 className="mb-1 font-weight-bold">
                            {" "}
                            <a >456</a>{" "}
                            <p className="text-muted ">Boys</p>
                          </h3>
                        </div>
                        <div className="col-md-6 col text-center float-end">
                          <h3 className="mb-1 font-weight-bold">
                            {" "}
                            <a >556</a>{" "}
                            <p className="text-muted ">Girls</p>
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-xl-4">
                    <div className="card custom-card">
                      <div className="card-bodyy">
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="product-content">
                              <h3 className="title">
                                <a href="#">ALUMNI STUDENTS</a>
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                        <div className="col-md-6 col justify-content-center text-center">
                          <h3 className="mb-1 font-weight-bold">
                            {" "}
                            <a >456</a>{" "}
                            <p className="text-muted ">Boys</p>
                          </h3>
                        </div>
                        <div className="col-md-6 col text-center float-end">
                          <h3 className="mb-1 font-weight-bold">
                            {" "}
                            <a >556</a>{" "}
                            <p className="text-muted ">Girls</p>
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-xl-4">
                    <div className="card custom-card">
                      <div className="card-bodyy">
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="product-content">
                              <h3 className="title">
                                <a href="#">TRANSPORT</a>
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                        <div className="col-md-6 col justify-content-center text-center">
                          <h3 className="mb-1 font-weight-bold">
                            {" "}
                            <a >456</a>{" "}
                            <p className="text-muted ">Allocated Student</p>
                          </h3>
                        </div>
                        <div className="col-md-6 col text-center float-end">
                          <h3 className="mb-1 font-weight-bold">
                            {" "}
                            <a >556</a>{" "}
                            <p className="text-muted ">Total Student</p>
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/*End row*/}
              {/*row*/}
              <div className="row row-sm">
                <div
                  className="col-sm-12 col-md-12 col-lg-6 col-xl-6"
                  data-wow-delay="1.5s"
                >
                  <Card className="custom-card">
                    <Card.Header>
                      <div className="d-md-flex ms-auto">
                        <label className="main-content-label my-auto pt-2"><i className="fa fa-bullhorn headericons"></i> Announcement</label>
                        <div className="ms-auto mt-3 d-flex">
                          <div className="ms-auto">
                            <a
                              href="javascript:void(0)"
                              className="option-dots"
                              data-bs-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <i className="fe fe-more-vertical"></i>
                            </a>
                            <div className="dropdown-menu">
                              <a className="dropdown-item" href="javascript:void(0)">Add New</a>
                              <a className="dropdown-item" href="javascript:void(0)">All Notification</a>
                              <a className="dropdown-item" href="javascript:void(0)">Status</a>
                              <div className="dropdown-divider"></div>
                              <a className="dropdown-item" href="javascript:void(0)">
                                <i className="fa fa-cog me-2"></i> Settings
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Card.Header>
                    <Card.Body
                      id="auto-scroll"
                      onMouseEnter={() => clearInterval(window.scrollInterval)}
                      onMouseLeave={startAutoScroll}
                      style={{
                        maxHeight: '350px',
                        overflow: 'hidden',
                        position: 'relative',
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      <ul
                        className="visitor mb-0 d-block users-images list-unstyled list-unstyled-border"
                        id="announcement-list"
                      >
                        {[...Array(10)].map((_, index) => (
                          <li key={index} className="d-flex align-items-center mb-3">
                            <div className="flex-shrink-0">
                              <div className="main-avatar avatar-md online"></div>
                            </div>
                            <div className="ms-3 flex-grow-1">
                              <p className="tx-16 text-dark mb-0 tx-semibold">Anual Sports Day</p>
                              <p className="mb-0 text-muted">12-12-2024</p>
                            </div>
                            <a href="#" class="me-2 mt-1"><span class="badge bg-success-light">View</span></a>
                          </li>
                        ))}
                      </ul>
                    </Card.Body>
                  </Card>
                </div>
                <div
                  className="col-sm-12 col-md-12 col-lg-6 col-xl-6"
                  data-wow-delay="1.5s"
                >
                  <Card className="custom-card">
                    <Card.Header className="">
                      <div className="d-md-flex ms-auto">
                        <label className="main-content-label my-auto pt-2"><i className="fa fa-birthday-cake headericons"></i> Today Birthday List</label>
                        <div className="ms-auto mt-3 d-flex">
                          <div className="ms-auto">
                            <a
                              href="javascript:void(0)"
                              className="option-dots"
                              data-bs-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <i className="fe fe-more-vertical"></i>
                            </a>
                            <div className="dropdown-menu">
                              <a className="dropdown-item" href="javascript:void(0)">Add New</a>
                              <a className="dropdown-item" href="javascript:void(0)">All Notification</a>
                              <a className="dropdown-item" href="javascript:void(0)">Status</a>
                              <div className="dropdown-divider"></div>
                              <a className="dropdown-item" href="javascript:void(0)">
                                <i className="fa fa-cog me-2"></i> Settings
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Card.Header>
                    <Card.Body
                      id="birthday-scroll"
                      onMouseEnter={() => clearInterval(window.scrollInterval)}
                      onMouseLeave={startBirthdayScroll}
                      style={{
                        maxHeight: '350px',
                        overflow: 'hidden',
                        position: 'relative',
                      }}
                    >
                      <ul
                        className="visitor mb-0 d-block users-images list-unstyled list-unstyled-border"
                        id="birthday-list"
                      >
                        {[...Array(10)].map((_, index) => (
                          <li key={index} className="media d-flex mb-3 mt-0 pt-0">
                            <img
                              alt="avatar"
                              className="me-3 rounded-circle avatar avatar-md"
                              src={require("../../assets/images/user.png")}
                            />
                            <div className="media-body mb-1 announcement">
                              <div className="float-end">
                                <a href="#" class="me-2 mt-1"><span class="badge bg-success-light">View</span></a>
                              </div>
                              <h5 className="media-title tx-16 mb-0">Ajithkumar T {index + 1}</h5>
                              <p className="mb-0 tx-13 text-muted">XII - A</p>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </Card.Body>
                  </Card>

                </div>

                <div className="col-lg-12">
                  <div className="card custom-card mg-b-20">
                    <Card className="custom-card">
                      <Card.Header className="">
                        <div className="d-md-flex ms-auto">
                          <label className="main-content-label my-auto pt-2"><i className="typcn typcn-location headericons"></i> Vehicle Location</label>
                          <div className="ms-auto mt-3 d-flex">
                            <div class="ms-auto">
                              <a href="javascript:void(0)" class="option-dots" data-bs-toggle="dropdown"
                                aria-haspopup="true" aria-expanded="false"><i
                                  class="fe fe-more-vertical"></i></a>
                              <div class="dropdown-menu">
                                <a class="dropdown-item" href="javascript:void(0)">Add New</a>
                                <a class="dropdown-item" href="javascript:void(0)">All Notification</a>
                                <a class="dropdown-item" href="javascript:void(0)">Status</a>
                                <div class="dropdown-divider"></div>
                                <a class="dropdown-item" href="javascript:void(0)"><i class="fa fa-cog me-2"></i>
                                  Settings</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Card.Header>
                      <Card.Body>
                        <img
                          alt="avatar"
                          className=""
                          src={require("../../assets/images/map admin.jpg")}
                        />
                      </Card.Body>
                    </Card>
                  </div>
                </div>
                {/* col end */}
              </div>
              {/* Row end */}
            </div>
            {/* col end */}

            <div className="col-sm-12 col-lg-12 col-xl-4 mt-xl-4">
              <div className="card">
                <div className="card-body">
                  <div className="table-responsive widget-media dlab-scroll height370 ">
                    <div className="d-md-flex mb-4">
                      <label className="main-content-title tx-16 mt-3">
                        ATTENDANCE
                      </label>
                      <div className="ms-auto mt-3 d-flex">
                        <div className="d-flex text-muted tx-13">
                          <span className="legend bg-danger rounded-circle" />
                          Not Marked
                        </div>
                        <div className="d-flex text-muted tx-13">
                          <span className="legend bg-success rounded-circle" />
                          Marked
                        </div>
                      </div>
                    </div>

                    <table className="table orderbookTable">
                      <thead>
                        <tr>
                          <th>Class</th>
                          <th>Division</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>LKG</td>
                          <td>
                            <div className="btn-group" role="group">
                              <button type="button" className="btn btn-danger">
                                A
                              </button>
                              <button
                                type="button"
                                className="btn btn-success btn-wave"
                              >
                                B
                              </button>
                              <button
                                type="button"
                                className="btn btn-success btn-wave"
                              >
                                C
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>UKG</td>
                          <td>
                            <div className="btn-group" role="group">
                              <button
                                type="button"
                                className="btn btn-danger btn-wave"
                              >
                                A
                              </button>
                              <button
                                type="button"
                                className="btn btn-success btn-wave"
                              >
                                B
                              </button>
                              <button
                                type="button"
                                className="btn btn-success btn-wave"
                              >
                                C
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>I</td>
                          <td>
                            <div className="btn-group" role="group">
                              <button
                                type="button"
                                className="btn btn-danger btn-wave"
                              >
                                A
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>II</td>
                          <td>
                            <div className="btn-group" role="group">
                              <button
                                type="button"
                                className="btn btn-danger btn-wave"
                              >
                                A
                              </button>
                              <button
                                type="button"
                                className="btn btn-success btn-wave"
                              >
                                B
                              </button>
                              <button
                                type="button"
                                className="btn btn-success btn-wave"
                              >
                                C
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>III</td>
                          <td>
                            <div className="btn-group" role="group">
                              <button
                                type="button"
                                className="btn btn-danger btn-wave"
                              >
                                A
                              </button>
                              <button
                                type="button"
                                className="btn btn-success btn-wave"
                              >
                                B
                              </button>
                              <button
                                type="button"
                                className="btn btn-success btn-wave"
                              >
                                C
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>IV</td>
                          <td>
                            <div className="btn-group" role="group">
                              <button
                                type="button"
                                className="btn btn-danger btn-wave"
                              >
                                A
                              </button>
                              <button
                                type="button"
                                className="btn btn-success btn-wave"
                              >
                                B
                              </button>
                              <button
                                type="button"
                                className="btn btn-success btn-wave"
                              >
                                C
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>V</td>
                          <td>
                            <div className="btn-group" role="group">
                              <button
                                type="button"
                                className="btn btn-danger btn-wave"
                              >
                                A
                              </button>
                              <button
                                type="button"
                                className="btn btn-success btn-wave"
                              >
                                B
                              </button>
                              <button
                                type="button"
                                className="btn btn-success btn-wave"
                              >
                                C
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>VI</td>
                          <td>
                            <div className="btn-group" role="group">
                              <button
                                type="button"
                                className="btn btn-danger btn-wave"
                              >
                                A
                              </button>
                              <button
                                type="button"
                                className="btn btn-success btn-wave"
                              >
                                B
                              </button>
                              <button
                                type="button"
                                className="btn btn-success btn-wave"
                              >
                                C
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>VII</td>
                          <td>
                            <div className="btn-group" role="group">
                              <button
                                type="button"
                                className="btn btn-danger btn-wave"
                              >
                                A
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>VIII</td>
                          <td>
                            <div className="btn-group" role="group">
                              <button
                                type="button"
                                className="btn btn-danger btn-wave"
                              >
                                A
                              </button>
                              <button
                                type="button"
                                className="btn btn-danger btn-wave"
                              >
                                B
                              </button>
                              <button
                                type="button"
                                className="btn btn-success btn-wave"
                              >
                                C
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>IX</td>
                          <td>
                            <div className="btn-group" role="group">
                              <button
                                type="button"
                                className="btn btn-danger btn-wave"
                              >
                                A
                              </button>
                              <button
                                type="button"
                                className="btn btn-danger btn-wave"
                              >
                                B
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>X</td>
                          <td>
                            <div className="btn-group" role="group">
                              <button
                                type="button"
                                className="btn btn-danger btn-wave"
                              >
                                A
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>XI</td>
                          <td>
                            <div className="btn-group" role="group">
                              <button
                                type="button"
                                className="btn btn-danger btn-wave"
                              >
                                A
                              </button>
                              <button
                                type="button"
                                className="btn btn-danger btn-wave"
                              >
                                B
                              </button>
                              <button
                                type="button"
                                className="btn btn-success btn-wave"
                              >
                                C
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>XII</td>
                          <td>
                            <div className="btn-group" role="group">
                              <button
                                type="button"
                                className="btn btn-danger btn-wave"
                              >
                                A
                              </button>
                              <button
                                type="button"
                                className="btn btn-danger btn-wave"
                              >
                                B
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="card custom-card mg-t-30">
                <Card className="custom-card">
                  <Card.Header className="">
                    <div className="d-md-flex ms-auto">
                      <label className="main-content-label my-auto pt-2"><i className="fa fa-calendar headericons"></i> Events calendar</label>
                      <div className="ms-auto mt-3 d-flex">
                        <div class="ms-auto">
                          <a href="javascript:void(0)" class="option-dots" data-bs-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false"><i
                              class="fe fe-more-vertical"></i></a>
                          <div class="dropdown-menu">
                            <a class="dropdown-item" href="javascript:void(0)">Add New</a>
                            <a class="dropdown-item" href="javascript:void(0)">All Notification</a>
                            <a class="dropdown-item" href="javascript:void(0)">Status</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item" href="javascript:void(0)"><i class="fa fa-cog me-2"></i>
                              Settings</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <img
                      alt="avatar"
                      className=""
                      // src={require("../../assets/images/Screenshot 2024-12-04 123706.png")}
                    />
                  </Card.Body>
                </Card>
              </div>
              <div className="card custom-card mg-t-30">
                <Card className="custom-card">
                  <Card.Header className="">
                    <div className="d-md-flex ms-auto">
                      <label className="main-content-label my-auto pt-2"><i className="mdi mdi-account-check headericons"></i> Present Absent List </label>
                      <div className="ms-auto mt-3 d-flex">
                        <div class="ms-auto">
                          <a href="javascript:void(0)" class="option-dots" data-bs-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false"><i
                              class="fe fe-more-vertical"></i></a>
                          <div class="dropdown-menu">
                            <a class="dropdown-item" href="javascript:void(0)">Add New</a>
                            <a class="dropdown-item" href="javascript:void(0)">All Notification</a>
                            <a class="dropdown-item" href="javascript:void(0)">Status</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item" href="javascript:void(0)"><i class="fa fa-cog me-2"></i>
                              Settings</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <img
                      alt="avatar"
                      className=""
                      // src={require("../../assets/images/Screenshot 2024-12-03 205400.png")}
                    />
                  </Card.Body>
                </Card>
              </div>
            </div>

            {/* col end */}
          </div>
          {/* Row end */}
        </div>
      </div>
    </Fragment>
  );
}

Dashboard.propTypes = {};

Dashboard.defaultProps = {};

export default Dashboard;
